module.exports = __webpack_public_path__ + "df73ed44fdd297d5bcf8fcc55b18c1b8.svg";